// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2soTw","unreadBadge":"styles_unreadBadge__eS7bF","modalContent":"styles_modalContent__16wYw","modal":"styles_modal__1TtFi"};